import React, { useEffect, useState } from 'react'
import {
  Button,
  Box,
  useMediaQuery,
  Snackbar,
  Alert,
} from '@mui/material'
import { mainApi } from '../../../store/services/mainApi'
import { digitalAppApi } from '../../../store/services/digitalAppApi'
import { useNavigate } from 'react-router'
import { useDispatch } from 'react-redux'
import { setUserPermissions } from '../../../store/slices/userPermissions'

import AuthTextField from '../../Rcomp/AuthTextField/AuthTextField'
import { MuiTelInput } from 'mui-tel-input'

const Login = () => {
  const mobileView = useMediaQuery('(max-width: 798px)')
  const TG = typeof window !== 'undefined' ? window.Telegram?.WebApp : undefined

  const [siteId, setSiteId] = useState('')
  const dispatch = useDispatch()
  const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'success' })

  const [login, { isSuccess }] =
    digitalAppApi.useLoginAdminMutation()

  const [updateTelegramDataAdminAcc, { data: resultUpdatePaidAdminAcc, isSuccess: isSuccessUpdatePaidAdminAcc }] = digitalAppApi.useUpdateTelegramDataAdminAccMutation()

  const {
    data: siteParams,
    isSuccess: isSiteParamsSuccess,
  } = mainApi.useGetSiteParamsByIdQuery(
    { _id: siteId },
    {
      skip: !siteId,
    },
  )
  const navigate = useNavigate()

  useEffect(() => {
    if (siteParams) {
      localStorage.setItem(
        'site',
        JSON.stringify(siteParams),
      )
      localStorage.setItem('name', siteParams.name)
    }
  }, [siteParams])

  const [formData, setFormData] = useState({
    phone: '',
    password: '',
  })

  const [phone, setPhone] = useState('')

  const handleChangePhone = (value) => {
    setPhone(value)
  }

  const handleChange = (event) => {
    const { name, value } = event.target
    setFormData({ ...formData, [name]: value })
  }

  useEffect(() => {
    if (
      localStorage.getItem('acc') &&
      localStorage.getItem('site')
    ) {
      navigate('/admin/orders')
    }
  }, [navigate])

  useEffect(() => {
    if (isSuccess) {
      // После успешного логина устанавливаем siteId
      const accountData = JSON.parse(
        localStorage.getItem('acc'),
      )
      if (accountData?.site) {
        setSiteId(accountData.site)
      }
    }
  }, [isSuccess])

  useEffect(() => {
    if (isSiteParamsSuccess && siteParams) {
      // После успешного получения siteParams перенаправляем пользователя
      navigate('/admin/orders')
    }
  }, [isSiteParamsSuccess, siteParams, navigate])

  const handleSubmit = async (event) => {
    event.preventDefault()
    try {
      const res = await login({
        data: {
          phone: phone,
          password: formData.password,
        },
      }).unwrap()

      setSnackbar({ open: true, message: 'Login success', severity: 'success' })

      // Если с бэкенда пришли права, используем их
      // Иначе генерируем по роли
      const userRole = res.role || 'viewer'
      const userPermissions = res.actions || null




     if(!res?.tg?.id && TG?.initDataUnsafe?.user?.id){
       await updateTelegramDataAdminAcc({data: {
           _id: res._id || "",
           tg: res?.tg?.id ? res?.tg : TG?.initDataUnsafe?.user
         }})
     }

      const userData = {
        ...res,
        role: userRole,
        actions: userPermissions,
        tg: res?.tg?.id ? res?.tg : TG?.initDataUnsafe?.user,
        token: res?.token ?? undefined,
      }

      localStorage.setItem('acc', JSON.stringify(userData))

      // Устанавливаем права пользователя в Redux
      dispatch(
        setUserPermissions({
          role: userRole,
          permissions: userPermissions,
        }),
      )

      setSiteId(res.site) // Предполагаем, что res.site содержит siteId
      dispatch(
        mainApi.util.invalidateTags(['ShipmentOrders']),
      )
      dispatch(mainApi.util.invalidateTags(['Products']))
      dispatch(mainApi.util.invalidateTags(['History']))
      dispatch(mainApi.util.invalidateTags(['Contacts']))
      // Перенаправление будет выполнено в useEffect, когда siteId изменится
    } catch (e) {
      setSnackbar({
        open: true,
        message: e?.data?.message || 'Something went wrong. Try again later',
        severity: 'error',
      })
    }
  }

  const handleCloseSnackbar = () => setSnackbar((s) => ({ ...s, open: false }))

  return (
    <>
      <form
        onSubmit={handleSubmit}
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          minHeight: 'max-content',
          backgroundColor: '#f5f5f5',
          padding: mobileView ? '24px 20px' : '48px 80px',
          overflow: 'auto',
          borderRadius: '20px',
          gap: '4px',
          maxWidth: 420,
          width: '100%',
        }}
      >
        <h2
          style={{
            textAlign: 'center',
            color: '#5FC56E',
            fontSize: '40px',
            fontWeight: '700',
            fontFamily: 'Montserrat',
            margin: '0 0 8px 0',
            lineHeight: '0.8',
          }}
        >
          WELCOME <br />
          <span
            style={{
              fontSize: '25px',
              fontWeight: '700',
              margin: '0',
            }}
          >
            to TPO
            <span style={{ color: '#186419' }}>Admin</span>
          </span>
        </h2>

        <h3
          style={{
            textAlign: 'center',
            color: '#186419',
            fontFamily: 'Montserrat',
            margin: '0 0 24px 0',
            fontSize: '1.1rem',
          }}
        >
          Sign in
        </h3>
        <Box sx={{ width: '100%', maxWidth: 320 }}>
          <p
            style={{
              margin: '0 0 6px 0',
              fontFamily: 'Montserrat',
              fontWeight: '700',
              fontSize: '12px',
            }}
          >
            Phone
          </p>
        <MuiTelInput
          required
          MenuProps={{
            PaperProps: {
              style: { maxHeight: '200px', width: '300px' },
            },
          }}
          InputProps={{
            disableUnderline: true,
            sx: {
              border: 'none',
            },
          }}
          variant='standard'
          sx={{
            width: '100%',
            // margin: '15px',

            '& .MuiTelInput-TextField': {
              border: 'none',
            },
            '& .MuiTelInput-IconButton': {
              border: '1px solid #186419',
              width: 50,
              height: 40,
              borderRadius: '20px 0px 0px 20px',

              '&:hover': {
                backgroundColor: '#186419',
                color: 'white',
              },
            },
            '& .MuiInputBase-input': {
              paddingTop: 1,
              paddingBottom: 1,
              paddingLeft: 1,
              // paddingRight: 10,
              borderTop: '1px solid #186419',
              borderBottom: '1px solid #186419',
              borderRight: '1px solid #186419',
              borderLeft: '1px solid #186419',

              borderTopRightRadius: '20px',
              borderBottomRightRadius: '20px',
              // borderLeft: '1px solid #186419',
            },
            '& .MuiInputBase-root': {
              border: 'none',
            },
          }}
          name='phone'
          value={phone}
          onChange={handleChangePhone}
        />
      </Box>
      {/* <AuthTextField label='Phone' name='phone' value={formData.phone} onChange={handleChange} /> */}
        <Box sx={{ mt: 2, width: '100%', maxWidth: 320 }}>
          <AuthTextField
            label='Password'
            name='password'
            value={formData.password}
            onChange={handleChange}
          />
        </Box>
      {/* <TextField
        type='email'
        required
        label='Email'
        variant='outlined'
        name='email'
        value={formData.email}
        onChange={handleChange}
        fullWidth
        margin='normal'
      /> */}
      {/* <TextField
        label='Password'
        type='password'
        variant='outlined'
        name='password'
        value={formData.password}
        onChange={handleChange}
        fullWidth
        margin='normal'
        required
      /> */}
        <Button
          sx={{
            width: '100%',
            maxWidth: 320,
            mt: 2.5,
            backgroundColor: '#5FC56E',
            borderRadius: '30px',
          }}
          type='submit'
          variant='contained'
          color='primary'
        >
          Login
        </Button>
      </form>

      <Snackbar
        open={snackbar.open}
        autoHideDuration={5000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      >
        <Alert
          onClose={handleCloseSnackbar}
          severity={snackbar.severity}
          variant='filled'
          sx={{
            backgroundColor: snackbar.severity === 'success' ? '#5FC56E' : undefined,
            '&.MuiAlert-filledError': { backgroundColor: '#d32f2f' },
          }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
    </>
  )
}

export default Login
